/**
 * ID задачи на сервере: при офлайн-синке в IndexedDB локальный ++id ≠ server_id.
 */
export function taskServerId(task) {
  if (!task) return null;
  if (task.server_id != null && task.server_id !== '') return task.server_id;
  if (task.temp_id) return task.temp_id;
  return task.id;
}
